<template>
  <el-col>
    <el-card class="data" v-loading="loading_territorial">
      <div class="flex-center" slot="header">
        <img class="report-img" src="@/assets/images/territorial.svg" alt="" />
        <span>TERRITORIAL</span>
      </div>
      <div class="flex-space-between d-md-grid grid-order-chart">
        <div class="popularity">
          <p style="margin-left: 7px;">POPULARITY</p>
          <div class="popularity-wrap">
            <div
              class="flex-space-between popularity-info"
              v-for="(t, index) in territorial"
              :key="index"
            >
              <div class="flex-center">
                <!--<div
                  class="color-square"
                  :style="
                    `background: ${popularityColor(
                      Math.trunc(popularity(t.video))
                    )}`
                  "
                ></div>-->
                <p class="name">{{ t.name }}</p>
              </div>
              <p class="value">{{ t.video }} ({{ popularity(t.video) }}%)</p>
            </div>
          </div>
        </div>
        <GChart
          class="chart"
          type="GeoChart"
          :settings="{
            packages: ['geochart'],
            mapsApiKey: 'AIzaSyCIVYFLXMrahuApcVFlAh1GIVGj2SNfqow'
          }"
          :data="territorial_chart"
          :options="GeoChartSett"
          v-if="territorial_chart.length > 1"
        />
        <div v-else class="no-data"><span>No Data</span></div>
        <div class="legend">
          <img src="@/assets/images/legend-chart-territorial.svg" />
          <p>Popularity</p>
        </div>
      </div>
    </el-card>
  </el-col>
</template>

<script>
import { mapState, mapGetters, mapActions, mapMutations } from 'vuex'
import { GChart } from 'vue-google-charts'

export default {
  components: {
    GChart
  },

  data() {
    return {
      selectedCommand: 'Date range',
      colors_num: 8
    }
  },

  watch: {
    artist_track: function(valN, valO) {
      if (valN !== null) {
        this.readTerritorial()
      }
    },
    artist_label: function(valN, valO) {
      if (valN !== null) {
        this.readTerritorial()
      }
    }
  },

  computed: {
    ...mapState('artistDashboard', [
      'GeoChartSett',
      'loading_territorial',
      'artist_track',
      'artist_label',
      'territorial'
    ]),
    ...mapGetters('artistDashboard', ['territorial_chart']),

    maxPercentage() {
      return (
        (this.territorial[0].video / this.sum(this.territorial)) *
        100
      ).toFixed(1)
    }
  },

  methods: {
    ...mapActions('artistDashboard', ['readTerritorial']),
    ...mapMutations('artistDashboard', ['setTerritorialData']),
    handleCommand(command) {
      this.selectedCommand = command
    },
    popularity(video) {
      return ((video / this.sum(this.territorial)) * 100).toFixed(1)
    },
    percentageRange(value) {
      return Math.ceil(
        ((this.maxPercentage / this.colors_num) * value).toFixed(1)
      )
    },
    popularityColor(p) {
      // Geo chart is mixing these colors depending on the value
      switch (true) {
        case p < this.percentageRange(1):
          return '#F906E1' // pink
        case p >= this.percentageRange(1) && p <= this.percentageRange(2):
          return '#AD0AFC' // purple
        case p > this.percentageRange(2) && p <= this.percentageRange(3):
          return '#0606F9' // blue dark
        case p > this.percentageRange(3) && p <= this.percentageRange(4):
          return '#07F9F9' // blue light
        case p > this.percentageRange(4) && p <= this.percentageRange(5):
          return '#09FB19' // green
        case p > this.percentageRange(5) && p <= this.percentageRange(6):
          return '#FEE507' // yellow
        case p > this.percentageRange(6) && p <= this.percentageRange(7):
          return '#FF7F00' // orange
        case p > this.percentageRange(7):
          return '#FC0000' // red
      }
    }
  },

  created() {
    this.readTerritorial()
  },

  destroyed() {
    this.setTerritorialData([])
  }
}
</script>
